module.exports = __webpack_public_path__ + "media/components/resort-webcams/static/icon--panorama-9fdb330084ce8f551f9d5db0ded9a93d.svg";